import { WidgetDrawer as WidgetDrawerComponent } from "./WidgetDrawer.component";

export const DefaultWidgetDrawer = () => (
  <WidgetDrawerComponent />
);

export const WidgetDrawer = DefaultWidgetDrawer;
